export default "__VITE_ASSET__DS5sdW8H__"